import React, { useState, useCallback, useMemo } from 'react'
import t from '~t'
import { API_ENDPOINT_URL } from '~data/constants/app'
import sessionStorage from '~modules/sessionStorage'

import { Helmet } from 'react-helmet'
import { Link, useSearchParams } from 'react-router-dom'
import { Layout, Text, Label } from '~co/common/form'
import Button from '~co/common/button'
import Preloader from '~co/common/preloader'
import Social from '../social'
import Alert from '~co/common/alert'
import { connect } from 'react-redux'
import { userStatus, errorReason } from '~data/selectors/user'
import { loginWithPassword } from '~data/actions/user'

function AccountLogin({ status, errorObj, loginWithPassword }) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [search] = useSearchParams()
    const redirect = sessionStorage.getItem('redirect') || ''

    const error = useMemo(()=>{
        const { error } = Object.fromEntries(new URLSearchParams(search))||{}
        return error
    }, [search])

    const onChangeEmailField = useCallback(e=>setEmail(e.target.value), [])
    const onChangePasswordField = useCallback(e=>setPassword(e.target.value), [])

    const onSubmit = useCallback(e=>{
        e.preventDefault()
        loginWithPassword({email, password})
    }, [email, password, loginWithPassword])

    const statusLogin = status.login
    const errorRaw = errorObj.login || error

    return (
        <form onSubmit={onSubmit}>
            <Helmet><title>{t.s('signIn')}</title></Helmet>

            <Layout>
                {errorRaw ? (
                    <Alert variant='danger'>{String((errorRaw && errorRaw.message) ? errorRaw.message : errorRaw)}</Alert>
                ) : null}

                <Label>Email {t.s('or')} {t.s('username').toLowerCase()}</Label>
                <Text
                    type='text'
                    name='email'
                    autoFocus
                    required
                    inputMode='email'
                    autoCapitalize='none'
                    spellCheck='false'
                    value={email}
                    disabled={statusLogin=='loading'}
                    onChange={onChangeEmailField} />

                <Label>
                    {t.s('password')}
                    <Button 
                        as={Link}
                        size='small'
                        variant='link'
                        to='/account/lost'
                        tabIndex='1'>
                        {t.s('recoverPassword')}
                    </Button>
                </Label>
                <Text
                    type='password'
                    name='password'
                    required
                    disabled={statusLogin=='loading'}
                    value={password}
                    onChange={onChangePasswordField} />

                <input type='hidden' name='redirect' value={redirect} />

                {statusLogin == 'loading' ? (
                    <Button variant='flat' data-block>
                        <Preloader />
                    </Button>
                ) : (
                    <Button
                        as='input'
                        type='submit'
                        variant='primary'
                        data-block
                        value={t.s('signIn')} />
                )}

                <Social />

                <Button
                    as={Link}
                    to='/account/signup'
                    variant='link'
                    data-block>
                    {t.s('signUp')}
                </Button>
            </Layout>
        </form>
    )
}

export default connect(
    state=>({
        status: userStatus(state),
        errorObj: errorReason(state)
    }),
    { loginWithPassword }
)(AccountLogin)